/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ItemsCertifications } from '../../models/items-certifications';
import { XMetadata } from '../../models/x-metadata';

export interface ReadItemsCertifications$Params {

/**
 * Control what fields are being returned in the object.
 */
  fields?: Array<string>;

/**
 * A limit on the number of objects that are returned.
 */
  limit?: number;

/**
 * What metadata to return in the response.
 */
  meta?: string;

/**
 * How many items to skip when fetching data.
 */
  offset?: number;

/**
 * How to sort the returned items. `sort` is a CSV of fields used to sort the fetched items. Sorting defaults to ascending (ASC) order but a minus sign (` - `) can be used to reverse this to descending (DESC) order. Fields are prioritized by their order in the CSV. You can also use a ` ? ` to sort randomly.
 */
  sort?: Array<string>;

/**
 * Select items in collection by given conditions.
 */
  filter?: any;

/**
 * Filter by items that contain the given search query in one of their fields.
 */
  search?: string;
}

export function readItemsCertifications(http: HttpClient, rootUrl: string, params?: ReadItemsCertifications$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'data'?: Array<ItemsCertifications>;
'meta'?: XMetadata;
}>> {
  const rb = new RequestBuilder(rootUrl, readItemsCertifications.PATH, 'get');
  if (params) {
    rb.query('fields', params.fields, {"explode":false});
    rb.query('limit', params.limit, {});
    rb.query('meta', params.meta, {});
    rb.query('offset', params.offset, {});
    rb.query('sort', params.sort, {"explode":false});
    rb.query('filter', params.filter, {});
    rb.query('search', params.search, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'data'?: Array<ItemsCertifications>;
      'meta'?: XMetadata;
      }>;
    })
  );
}

readItemsCertifications.PATH = '/items/certifications';
